import {
	TimeFormatter,
	TimeFormatters,
	TimeFormattersList,
	TimeLocale,
	TimeValue,
} from '@app/hooks/contexts/timeController/timeControllerTypes'
import dayjs from 'dayjs'
import { timeLocales } from '@app/hooks/contexts/timeController/timeLocales'

export const formatter =
	(format?: string) =>
	(value?: TimeValue): string => {
		return format ? dayjs(value).format(format) : dayjs(value).format()
	}

export const timeFormatters = (
	timeLocale: TimeLocale = 'us'
): TimeFormattersList => {
	return {
		tf0: formatter(),
		tf: formatter(timeLocales[timeLocale].tf),
		df: formatter(timeLocales[timeLocale].df),
		df1: formatter(timeLocales[timeLocale].df1),
		df2: formatter(timeLocales[timeLocale].df2),
		df3: formatter(timeLocales[timeLocale].df3),
		df4: formatter(timeLocales[timeLocale].df4),
		df5: formatter(timeLocales[timeLocale].df5),
		df6: formatter(timeLocales[timeLocale].df6),
		df7: formatter(timeLocales[timeLocale].df7),
		df8: formatter(timeLocales[timeLocale].df8),
		df9: formatter(timeLocales[timeLocale].df9),
		tdf1: formatter(timeLocales[timeLocale].tdf1),
		tdf2: formatter(timeLocales[timeLocale].tdf2),
		tdf3: formatter(timeLocales[timeLocale].tdf3),
	}
}

export const selectTimeFormatter = (
	timeLocale?: TimeLocale,
	formatterType?: TimeFormatters
): TimeFormatter => {
	if (!timeLocale || !formatterType) return formatter()

	const formatters = timeFormatters(timeLocale)

	return formatters[formatterType]
}
